/**
 * The `DocumentsPort` implementation, shared by both adapters.
 *
 * Uploaded files are local browser storage, not a server resource, so there is
 * one implementation rather than a static/HTTP pair. When a document endpoint
 * exists, the HTTP adapter can wrap this — POST on write, keep IndexedDB as the
 * offline cache — without anything above the port changing.
 */

import type { DocumentsPort } from '../ports';
import {
  deleteDocument,
  getDocument,
  isDocumentStoreAvailable,
  listDocuments,
  putDocument,
  usedBytes,
} from './documentStore';

export const documentsAdapter: DocumentsPort = {
  listDocuments,
  getDocument,
  putDocument,
  deleteDocument,
  usedBytes,
  isAvailable: isDocumentStoreAvailable,
};
